import {useEffect, useState} from "react";
import styled from "styled-components";
import {BellIcon, PaymentIcon, PenIcon} from "ui/icons";
import {pageContainerStyles, themeColor, themeFontSize} from "ui/theme/index.js";
import {EditProfile} from "./section/editProfile/EditProfil";
import {NotificationSection} from "./section/notification/notification";
import {PayoutMethod} from "./section/payoutMethod/PayoutMethod";
import {useLocation} from "react-router-dom";

export const InstructorSettings = () => {
    const [activeTab, setActiveTab] = useState("editProfile");

    const location = useLocation();
    const {tab} = location.state || {};

    useEffect(() => {
        if (tab) {
            setActiveTab(tab);
        }
    }, [tab])

    return (
        <Container>
            <Sidebar>
                <Title>Settings</Title>
                <SidebarItem
                    active={activeTab === "editProfile"}
                    onClick={() => setActiveTab("editProfile")}
                >
                    <PenIcon/> Edit profile
                </SidebarItem>
                <SidebarItem
                    active={activeTab === "paymentMethod"}
                    onClick={() => setActiveTab("paymentMethod")}
                >
                    <PaymentIcon/> Payout Method
                </SidebarItem>
                <SidebarItem
                    active={activeTab === "notifications"}
                    onClick={() => setActiveTab("notifications")}
                >
                    <BellIcon/> Notifications
                </SidebarItem>
            </Sidebar>

            <Content>
                <SidebarContent active={activeTab === "editProfile"}>
                    <EditProfile/>
                </SidebarContent>
                <SidebarContent active={activeTab === "paymentMethod"}>
                    <PayoutMethod/>
                </SidebarContent>
                <SidebarContent active={activeTab === "notifications"}>
                    <NotificationSection/>
                </SidebarContent>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    ${pageContainerStyles}
    padding-block: 3rem;
    display: flex;
    gap: 3rem;
    font-family: var(--font-secondary);
    overflow: visible;
    margin-bottom: 4rem;
    min-height: var(--page-height);
`;

const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 250px;
    position: sticky;
    top: 0px;
    height: fit-content;
`;

const Title = styled.h1`
    padding: 1rem;
`;

const SidebarItem = styled.button`
    background: ${({active}) => (active ? themeColor("lightBlue") : "none")};
    color: ${({active}) => (active ? themeColor("blue") : themeColor("txt"))};
    border: none;
    padding: 1rem;
    text-align: left;
    cursor: pointer;
    border-radius: 8px;
    font-family: Montserrat;
    font-size: ${themeFontSize("regular")};
    font-weight: 600;
    transition: color 300ms ease, background-color 300ms ease;

    &:hover {
        color: ${themeColor("blue")};
        background-color: ${themeColor("lightBlue")};
    }

    display: flex;
    align-items: center;
    gap: 1rem;

    & svg {
        width: 20px;
        height: 20px;
        opacity: 0.8;
    }
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    border-left-width: 2px;
    border-left-color: ${themeColor("lightBlue")};
    border-left-style: solid;
`;

const SidebarContent = styled.div`
    display: ${({active}) => (active ? "flex" : "none")};
    flex-grow: 1;
    flex: 1;
    height: 100%;
    flex-direction: column;
    width: 100%;

    & > div {
        padding-top: 60px;
    }
`;

